import { useParams } from "react-router-dom";
import styled from "styled-components";
import { barberProfiles } from "../barberProfiles";
import ReservePlaceButton from "./buttons/ReservePlaceButton";
import { useEffect, useState } from "react";
import { Divider, Title, device } from "../styled";
import Lightbox from "yet-another-react-lightbox";
import Inline from "yet-another-react-lightbox/plugins/inline";

const Container = styled.div`
  position: relative;
  height: 100%;

  @media ${device.tablet} {
    padding: 80px 20% 0;
    background-color: #000;
    padding-top: 80px;
    margin-top: -80px;
  }

  ${Divider} {
    margin-bottom: 30px;
    @media ${device.tablet} {
      margin-bottom: 0;
    }
  }
`;

const ProfileImageContainer = styled.div`
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  height: 70svh;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 4px #fff solid;

  @media ${device.tablet} {
    align-items: end;
  }
`;

const BarberNameContainer = styled.div`
  box-shadow: #000 0px 20px 30px -10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
  border: 3px #fff solid;
  border-radius: 10px;
  height: 60px;
  width: 80%;
  color: #fff;
  font-size: 1.7rem;
  font-weight: bold;
  text-transform: uppercase;

  @media ${device.tablet} {
    margin-bottom: 100px;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  background-color: #000;
  padding: 30px 30px;
  text-align: center;
`;

const IntroductionFirst = styled.p`
  margin-top: 0;
  font-weight: bold;
  color: #fff;
  font-size: 1.3rem;
`;

const IntroductionSecond = styled.p`
  font-size: 1.1rem;
`;

const BarberIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 40px 0 20px 0;
`;

const BarberIconContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const Icon = styled.img`
  height: 50px;
`;

const SuggestionFirst = styled.p`
  font-size: 1.1rem;
`;
const SuggestionSecond = styled.i`
  font-size: 1.1rem;
  margin-bottom: 20px;
`;
const Experience = styled.p`
  text-transform: uppercase;
  font-weight: 600;
`;
const Location = styled.p`
  text-transform: uppercase;
  font-weight: 600;
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-bottom: 40px;
`;

const Barber = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const toggleOpen = (state) => () => setOpen(state);

  const updateIndex = ({ index: current }) => setIndex(current);
  const { barberName } = useParams();
  const barberData = barberProfiles.find((barber) => barber.id === barberName);
  const {
    name,
    introductionParts,
    suggestion,
    experience,
    profilePicture,
    reservationUrl,
    location,
    references,
  } = barberData;

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <Container>
      <ProfileImageContainer src={`/barber_profiles/${profilePicture}`}>
        <BarberNameContainer>{name}</BarberNameContainer>
      </ProfileImageContainer>
      <ContentContainer>
        <IntroductionFirst>{introductionParts.intFirst}</IntroductionFirst>
        <Divider />
        <IntroductionSecond>{introductionParts.intSecond}</IntroductionSecond>
        <SuggestionFirst>{suggestion.sugFirst}</SuggestionFirst>
        <SuggestionSecond>{`"${suggestion.sugSecond}"`}</SuggestionSecond>
        <Divider />
        <BarberIconWrapper>
          <BarberIconContainer>
            <Icon src={"/barber-white-chair.png"} />
            <Experience>{experience}</Experience>
          </BarberIconContainer>
          <BarberIconContainer>
            <Icon src={"/artist-scisor-marker.png"} />
            <Location>{location}</Location>
          </BarberIconContainer>
        </BarberIconWrapper>
        <ButtonContainer>
          <ReservePlaceButton
            first="Foglalj nálam!"
            second="Királyság!"
            url={reservationUrl}
          />
          {/*    <Link to={`munkaim`}>
            <ReservePlaceButton first="Munkáim" second="Királyság!" />
          </Link> */}
        </ButtonContainer>

        <Title>Munkáim</Title>
        <Divider />
        <Lightbox
          index={index}
          slides={references}
          plugins={[Inline]}
          on={{
            view: updateIndex,
            click: toggleOpen(true),
          }}
          carousel={{
            padding: 0,
            spacing: 0,
            imageFit: "cover",
          }}
          inline={{
            style: {
              width: "100%",
              maxWidth: "80svh",
              aspectRatio: "3.5 / 4",
              margin: "0 auto",
            },
          }}
        />

        <Lightbox
          open={open}
          close={toggleOpen(false)}
          index={index}
          slides={references}
          on={{ view: updateIndex }}
          animation={{ fade: 0 }}
          controller={{ closeOnPullDown: true, closeOnBackdropClick: true }}
        />
      </ContentContainer>
    </Container>
  );
};

export default Barber;
